import React from 'react';
import { Translate } from '@above-the-treeline/localization';

const DrcAvailabilityTypes = {
	notSet: {
		key: -1,
		label: <Translate id={'not_set'} />,
	},
	'999999': {
		key: 999999,
		label: <Translate id={'review_copy_available'} />,
	},
	'1': {
		key: 1,
		label: <Translate id={'available_for_request'} />,
	},
	'2': {
		key: 2,
		label: <Translate id={'available_for_download'} />,
	},
};

export default DrcAvailabilityTypes;
